"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = exports.LivePlayerInteractionType = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ComponentWrapper = _interopRequireDefault(require("../ComponentWrapper"));

var _Toggle = _interopRequireDefault(require("../Toggle"));

var _LivePlayer = require("./LivePlayer.style");

var _SlidoEmbed = _interopRequireDefault(require("./SlidoEmbed"));

var _VideoEmbed = _interopRequireWildcard(require("./VideoEmbed"));

var _VotemoEmbed = _interopRequireDefault(require("./VotemoEmbed"));

var _VideoOverlay = require("./VideoOverlay");

var _Banner = require("../Banner");

var LivePlayerInteractionType = {
  Slido: 'Slido',
  Votemo: 'Votemo'
};
exports.LivePlayerInteractionType = LivePlayerInteractionType;

function LivePlayerContent(_ref) {
  var interactionTool = _ref.interactionTool,
      liveTitleUrl = _ref.liveTitleUrl,
      type = _ref.type,
      overlay = _ref.overlay,
      videoUrl = _ref.videoUrl;
  // This flag is used to control whether the interaction tool will be shown,
  // it is passed to embed Components to determine the styling
  // Video full width toggle is only visible when there is an interaction tool
  var hasInteractionTool = !overlay && interactionTool && interactionTool.url; // The chat should be hidden if the overlay is visible

  var _ref2 = (0, _react.useState)(hasInteractionTool),
      _ref3 = _slicedToArray(_ref2, 2),
      showChat = _ref3[0],
      setShowChat = _ref3[1];

  var toggleClick = function toggleClick() {
    setShowChat(!showChat);

    if (interactionTool && typeof interactionTool.handleToggleClick === 'function') {
      interactionTool.handleToggleClick();
    }
  };

  var hasSlido = interactionTool && interactionTool.type === LivePlayerInteractionType.Slido && !!interactionTool.url;
  var hasVotemo = interactionTool && interactionTool.type === LivePlayerInteractionType.Votemo && !!interactionTool.url;

  var interactionToolProps = _objectSpread(_objectSpread({}, interactionTool), {}, {
    overlay: overlay
  });

  return /*#__PURE__*/_react.default.createElement(_ComponentWrapper.default, {
    columnWidth: [12]
  }, /*#__PURE__*/_react.default.createElement(_LivePlayer.LiveContainer, null, hasInteractionTool && /*#__PURE__*/_react.default.createElement(_LivePlayer.ToggleWrapper, null, /*#__PURE__*/_react.default.createElement(_Toggle.default, {
    checked: !showChat,
    handleToggle: toggleClick,
    id: "liveplayer-toggle",
    label: "Hide chat"
  })), /*#__PURE__*/_react.default.createElement(_LivePlayer.LiveWrapper, null, videoUrl ? /*#__PURE__*/_react.default.createElement(_VideoEmbed.default, {
    hasVotemo: hasVotemo,
    overlay: overlay,
    splitLogic: showChat,
    type: type,
    url: videoUrl
  }) : /*#__PURE__*/_react.default.createElement("h3", null, "Come again later, there is no live show happening at the moment"), hasInteractionTool && hasSlido && /*#__PURE__*/_react.default.createElement(_SlidoEmbed.default, interactionToolProps), hasInteractionTool && hasVotemo && /*#__PURE__*/_react.default.createElement(_VotemoEmbed.default, Object.assign({}, interactionToolProps, {
    hasVotemo: hasVotemo
  }))), liveTitleUrl && /*#__PURE__*/_react.default.createElement(_LivePlayer.LiveTitleWrap, {
    title: "Video Title",
    src: liveTitleUrl,
    frameBorder: "0"
  })));
}

LivePlayerContent.propTypes = {
  interactionTool: _propTypes.default.shape({
    banner: _propTypes.default.shape(_Banner.bannerPropTypes),
    handleToggleClick: _propTypes.default.func,
    type: _propTypes.default.oneOf(Object.values(LivePlayerInteractionType)),
    url: _propTypes.default.string
  }),
  liveTitleUrl: _propTypes.default.string,
  overlay: _propTypes.default.shape(_VideoOverlay.videoEmbedOverlayProps),
  type: _propTypes.default.oneOf(Object.values(_VideoEmbed.LivePlayerType)),
  videoUrl: _propTypes.default.string.isRequired
};
LivePlayerContent.defaultProps = {
  interactionTool: null,
  liveTitleUrl: '',
  overlay: null,
  type: _VideoEmbed.LivePlayerType.embed
};
var _default = LivePlayerContent;
exports.default = _default;